import { useCallback, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { FormSelectInput } from "../../../../../../common/components/masked_inputs/react_forms/form_select_input";
import { useForm } from "react-hook-form";
import { FuncionarioTreinamento } from "../../../../domain/models/funcionario_treinamento";
import { RelatorioFuncionarioTreinamentoForm } from "../../../schemas/Funcionarios_cadastro/relatorio_funcionario_treinamento_schema";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { FuncionarioAssinaturaDropDown } from "../../../../domain/models/funcionario_assinatura_dropdown";

import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * RelatorioTreinamentoModal
 */

type Props = {
  open: boolean,
  selectedFuncionarioTreinamento: FuncionarioTreinamento | null,
  funcionarioAssinaturas: FuncionarioAssinaturaDropDown[],
  onSubmit: (form: RelatorioFuncionarioTreinamentoForm) => void,
  onClose: (idAvaliacaoTreinamento: number | null, openState: boolean) => void,
};

export const RelatorioTreinamentoModal = ({
  open,
  selectedFuncionarioTreinamento,
  funcionarioAssinaturas,
  onSubmit,
  onClose,
}: Props) => {
  const hookForm = useForm<RelatorioFuncionarioTreinamentoForm>();

  useEffect(() => {
    if (open) {
      if (selectedFuncionarioTreinamento) {
        hookForm.setValue('exibirConteudoProgramatico', 1);
        hookForm.setValue('instrutorAssinatura', null);
      } else {
        hookForm.reset();
      }
    }
  }, [open, selectedFuncionarioTreinamento, hookForm]);

  const handleClose = useCallback(() => {
    onClose(null, false);
  }, [onClose]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(onSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>
      <DialogTitle>
        Relatorio treinamento
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Informações"} arrangement="fullRow">
          <>
            <FormSelectInput
              name='exibirConteudoProgramatico'
              label='Exibir Conteúdo Programático'
              showSelectionLabel={false}
              options={[
                { id: 1, label: 'Sim' },
                { id: 0, label: 'Não' },
              ]}
              reactHookForm={hookForm} />

            <DefaultFormAutocomplete
              name={'instrutorAssinatura'}
              label='Exibir Assinatura Instrutor'
              options={funcionarioAssinaturas}
              getOptionKey={x => x.idFuncionarioAssinatura}
              getOptionLabel={x => x.descricao}
              reactHookForm={hookForm} />

          </>
        </FormContainer>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              <PrimaryButton
                type="submit"
                buttonColor="primary-green">
                Gerar
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}